import React from 'react'
import { Provider } from 'react-redux'
import { initStore } from 'store/store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faSearch } from '@fortawesome/pro-regular-svg-icons'
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-light-svg-icons'

import Search from 'pages/Search'
import Layout from 'components/layouts/Layout'
import 'normalize.css'
import 'App.scss'
import 'typeface-roboto'
import PropTypes from 'prop-types'

library.add(faCoffee, faSearch, faAngleLeft, faAngleRight)

const App = function ({ searchPage }) {
  return (
    <Provider store={initStore()}>
      <Layout>
        <Search searchPage={searchPage} />
      </Layout>
    </Provider>
  )
}
App.propTypes = {
  searchPage: PropTypes.string
}

export default App
